import CreateReInspectionMultistepForm from './components/CreateReInspectionMultistepForm';

export const CreateReInspection = () => {
  return <CreateReInspectionMultistepForm />;
};

export default CreateReInspection;
